var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    className: "icon checkbox-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "icon__bg checkbox-icon__bg",
    cx: 16,
    cy: 16,
    r: 15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon__border checkbox-icon__border",
    d: "M16,32C7.18,32,0,24.82,0,16S7.18,0,16,0s16,7.18,16,16S24.82,32,16,32z M16,1.69         C8.11,1.69,1.69,8.11,1.69,16S8.11,30.31,16,30.31S30.31,23.89,30.31,16S23.89,1.69,16,1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon__mark checkbox-icon__mark",
    d: "M13.67,24c-0.01,0-0.01,0-0.02,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0         c-0.42-0.01-0.84-0.17-1.17-0.49c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0l-5.39-5.39c-0.52-0.52-0.72-1.34-0.38-2         c0.57-1.09,1.94-1.24,2.73-0.45l4.24,4.24l9.11-9.11c0.56-0.56,1.43-0.75,2.11-0.35c0.57,0.34,0.85,0.91,0.85,1.48         c0,0.43-0.17,0.87-0.5,1.2L14.87,23.5c0,0,0,0,0,0c-0.32,0.32-0.74,0.49-1.17,0.49c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0         c0,0,0,0,0,0C13.69,24,13.68,24,13.67,24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/icon-checkbox.06a3d798fe600b29a7c1f63f023594c9.svg";
export { ForwardRef as ReactComponent };